import React, { useState, useEffect } from 'react'
import { Button, message, Modal, Spin } from 'antd'
import { EntUser } from '../../../models/user'
import { AuthSliceMethods } from '../../../redux/slices/authSlice'
import { AppDispatch } from '../../../redux/root/root.store'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useLazyGetUserListQuery } from '../../../redux/api/userApis/usersApi'
import { UsersFilter } from '../../../models/filters/usersFilter'
import i18n from 'i18next'

interface IProps {
	show: boolean
	onHide: () => void
	onUnblockSuccess: () => void
}

export const UnblockUserModal = ({ show, onHide, onUnblockSuccess }: IProps) => {
	const dispatch: AppDispatch = useDispatch()
	const { t } = useTranslation()
	const [blockedUsers, setBlockedUsers] = useState<EntUser[]>([])

	const [getBlockedUsers, { data: users, isLoading }] = useLazyGetUserListQuery()

	useEffect(() => {
		if (show) {
			getBlockedUsers({ isBanned: true } as UsersFilter)
		}
	}, [show, getBlockedUsers])

	useEffect(() => {
		if (users?.res?.content) {
			setBlockedUsers(users.res.content)
		}
	}, [users])

	const unblockUser = async (user: EntUser) => {
		const updatedUser = { ...user, isBanned: false }

		setBlockedUsers(prev => prev.filter(u => u.id !== user.id))

		try {
			await dispatch(AuthSliceMethods.unblock(user))
			message.success(t('user.unblockSuccess'))
			onUnblockSuccess()
		} catch (error) {
			message.error(t('user.actionFailed'))
			setBlockedUsers(prev => [...prev, user])
		}
	}

	const confirmUnblock = (user: EntUser) => {
		Modal.confirm({
			title: t('user.unblockConfirmation'),
			content: t('user.unblockConfirmationMessage'),
			okText: t('general.confirm'),
			cancelText: t('general.cancel'),
			onOk: () => unblockUser(user),
		})
	}

	return (
		<Modal title={t('user.blocked_users')} open={show} onCancel={onHide} footer={null} width={1000}>
			<div style={{ maxHeight: '400px', overflow: 'auto' }}>
				{isLoading ? (
					<Spin />
				) : (
					<table>
						<thead>
							<tr>
								<th>{t('user.pin')}</th>
								<th>{t('user.organization')}</th>
								<th>{t('user.surname')}</th>
								<th>{t('user.name_employee')}</th>
							</tr>
						</thead>
						<tbody>
							{blockedUsers.length > 0 ? (
								blockedUsers.map(user => (
									<tr key={user.id}>
										<td>{user.pin}</td>
										<td>
											{user.roles
												?.find(role => role.governments && role.governments.length > 0)
												?.governments?.map(gov =>
													i18n.language === 'ru' ? gov.nameRu : gov.nameKy
												)
												.join(', ')}
										</td>
										<td>{user.secondName}</td>
										<td>{user.name}</td>
										<td>
											<Button type='primary' onClick={() => confirmUnblock(user)}>
												{t('user.unblock')}
											</Button>
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={3}>{t('user.noBlockedUsers')}</td>
								</tr>
							)}
						</tbody>
					</table>
				)}
			</div>
		</Modal>
	)
}
